import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Path, { d: "M17 22V2L7 7l10 5", stroke: `${color}` })
    }
  );
};
Icon.displayName = "FlagTriangleLeft";
const FlagTriangleLeft = memo(themed(Icon));
export {
  FlagTriangleLeft
};
//# sourceMappingURL=flag-triangle-left.js.map
